export const choosing_supplement_oms = [
    {
      Xpos_text: 25,
      Ypos_text: 100,
      page_eng: 15,
      page_thai: 14,
      info: [
        {sp: 'Bifidobacterium bifidum', less: ['Deficient', 'Slightly Deficient']},
        {sp: 'Lactobacillus gasseri', less: ['Deficient', 'Slightly Deficient']},
        {sp: 'Lactobacillus paracasei', less: ['Deficient', 'Slightly Deficient']},
        {sp: 'Lactobacillus rhamnosus', less: ['Deficient', 'Slightly Deficient']},
        {sp: 'Lactobacillus reuteri', less: ['Deficient', 'Slightly Deficient']}
      ]
    }
]

export const supplement_bacteria_map_oms = {
    '8x3 SA': {
      'Bifidobacterium bifidum': 100,
      'Lactobacillus gasseri': 100,
      'Lactobacillus paracasei': 100,
      'Lactobacillus rhamnosus': 1000,
      'Lactobacillus reuteri': 1000
    },
    '6x3 V': {
      'Lactobacillus gasseri': 1000,
      'Lactobacillus paracasei': 1000,
      'Lactobacillus rhamnosus': 100
    },
    '5x3 C': {
      'Bifidobacterium bifidum': 1000,
      'Lactobacillus reuteri': 100
    }
};

export const supplement_images_oms_eng = {
  '8x3 SA': {
      image_name: '8x3-SA',
      page: 15,
      x: 160,
      y: 560,
      width: 745,
      height: 'auto'
  },
  '6x3 V': {
      image_name: '6x3-V',
      page: 15,
      x: 160,
      y: 560,
      width: 745,
      height: 'auto'
  },
  '5x3 C': {
      image_name: '5x3-C',
      page: 15,
      x: 160,
      y: 560,
      width: 745,
      height: 'auto'
  },
};

export const supplement_images_oms_thai = {
  '8x3 SA': {
      image_name: '8x3-SA_thai',
      page: 31,
      x: 160,
      y: 560,
      width: 745,
      height: 'auto'
  },
  '6x3 V': {
      image_name: '6x3-V_thai',
      page: 31,
      x: 160,
      y: 560,
      width: 745,
      height: 'auto'
  },
  '5x3 C': {
      image_name: '5x3-C_thai',
      page: 31,
      x: 160,
      y: 560,
      width: 745,
      height: 'auto'
  },
};

// Function to calculate age from date of birth
export const calculateAge = (dateOfBirth) => {
  if (!dateOfBirth) return 0;
  let birthDate;
  if (typeof dateOfBirth === 'string') {
    const dateParts = dateOfBirth.split('/');
    if (dateParts.length === 3) {
      const part1 = parseInt(dateParts[0], 10);
      const part2 = parseInt(dateParts[1], 10);
      const year = parseInt(dateParts[2], 10);
      let month, day;
      if (part1 > 12) { // Assume DD/MM/YYYY if first part > 12
        day = part1;
        month = part2;
      } else if (part2 > 12) { // Assume MM/DD/YYYY if second part > 12
        month = part1;
        day = part2;
      } else { // Ambiguous, default to MM/DD/YYYY
        month = part1;
        day = part2;
      }
      birthDate = new Date(year, month - 1, day);
    } else {
      return 0;
    }
  } else if (dateOfBirth instanceof Date) {
    birthDate = dateOfBirth;
  } else {
    return 0;
  }
  if (isNaN(birthDate.getTime())) {
    return 0;
  }
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
};

// Function to get the final supplement list (BioGrace not available for OMS panel)
export const getFinalSupplementList = (selectedSupplements, dateOfBirth) => {
  return selectedSupplements;
};